import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Grupo } from 'src/app/admihair/api/dto/grupo';
import { Subgrupo } from 'src/app/admihair/api/dto/subgrupo';
import { GrupoService } from 'src/app/admihair/service/grupo.service';
import { SubgrupoService } from 'src/app/admihair/service/subgrupo.service';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';

@Component({
  selector: 'app-grupo-detalhar',
  templateUrl: './grupo-detalhar.component.html',
  styleUrls: ['./grupo-detalhar.component.scss']
})
export class GrupoDetalharComponent extends AdmihairBaseComponent implements OnInit {

  loadingGrupos: boolean = false;
  id?: number;
  grupo?: Grupo;
  grupoServico: boolean = false;
  listaSubgrupos: Subgrupo[] = [];

  constructor(
    private grupoService: GrupoService,
    private subgrupoService: SubgrupoService,
    private activatedRouter: ActivatedRoute, 
    erroService: ErroService,
    storageService: UtilStorageService) {
      super(erroService, storageService)
     }

  @ViewChild('f') form?: NgForm;

  ngOnInit(): void {
    this.loadingGrupos = true;
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_GRUPO');
    this.carregarIdGrupo();
    if (this.permissaoDetalhar) {
      this.carregarGrupoPorId();
    }
  }

  carregarGrupoPorId(){
    this.grupoService.buscarPorId(this.id).subscribe({
      next: (data: Grupo) => {
        this.grupo = data;
        this.carregarSubgrupos(this.grupo.id);
        if(this.grupo.planoContaEmpresa?.id === 4){
          this.grupoServico = true;
        }
      },
      error: (err: any) => {
        console.log('erro', err)
        this.loadingGrupos = false;
        this.exibirMensagemErro(err);
      }
    });
  }

  carregarIdGrupo(){
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if(idParam){
      this.id = parseInt(idParam);
    }
    
  }

  carregarSubgrupos(grupoId?: number){
    this.subgrupoService.listarSubgruposPorGrupoId(grupoId).subscribe({
      next: (data: Subgrupo[]) => {
        this.listaSubgrupos = data;
        this.loadingGrupos = false;
      },
      error: (err: any) => {
        this.loadingGrupos = false;
        this.exibirMensagemErro(err);
      }
    });
    
  }


}
